import {createGenericSlice, GenericActions, GenericState} from "../GenericSlice";
import {PayloadAction} from "@reduxjs/toolkit";
import {BusinessLeadsType} from "../../app/Subscriptions/types/CampaignsTypes.ts";
import { format } from "date-fns";

type State = {
    data: BusinessLeadsType[];
};

const initialState: State = {
    data: []
};

export const BusinessLeadsSlice = createGenericSlice({
    name: "BusinessLeadsSlice",
    initialState: initialState as GenericState<BusinessLeadsType[]>,
    reducers: {
        success: {
            reducer: (state: {
                data: BusinessLeadsType[];
                status: string;
            }, action: PayloadAction<BusinessLeadsType[]>) => {
                state.data = action.payload;
                state.status = 'finished';
            },
            prepare: (businessLeads: any) => {

                const BusinessLeadsArray: BusinessLeadsType[] = businessLeads.map((data: any) => {
                    return {
                        id: data.id,
                        campaignId: data.campaignId,
                        lastUpdateTime: data.shownInterestTime,
                        name: data.name,
                        notes: data.notes,
                        number: data.number,
                        pingCount: data.pingCount,
                        shownInterestTime: data.shownInterestTime,
                        status: data.status
                    };
                });

                return {payload: BusinessLeadsArray};
            }
        }
    }
});

export const actions = BusinessLeadsSlice.actions as GenericActions<BusinessLeadsType[]>;

export default BusinessLeadsSlice.reducer;
